<template>
	<div class="cb">
		<div class="cb-switch" :class="{ 'cb-switch--on': cookie.enabled }">
			<v-icon :color="cookie.enabled ? 'primary' : 'grey'" class="mr-3">mdi-cookie-outline</v-icon>
			<div class="cb-switch-text">
				<div class="cb-switch-label">Mostra la cookie bar</div>
				<div class="cb-muted">In basso a sinistra, finché il visitatore non sceglie «Accetta tutti» o «Solo necessari». Nel footer compare «Preferenze cookie» per cambiare idea</div>
			</div>
			<v-switch v-model="cookie.enabled" color="primary" hide-details class="mt-0 pt-0 ml-2" />
		</div>

		<template v-if="cookie.enabled">
			<div class="cb-switch cb-switch--small mt-3" :class="{ 'cb-switch--on': cookie.block_scripts }">
				<v-icon :color="cookie.block_scripts ? 'primary' : 'grey'" class="mr-3">mdi-shield-lock-outline</v-icon>
				<div class="cb-switch-text">
					<div class="cb-switch-label">Blocca gli script finché il visitatore non accetta</div>
					<div class="cb-muted">Gli script della sezione Script (testata, footer e azioni: Analytics, Pixel, Clarity…) partono solo dopo «Accetta tutti»</div>
				</div>
				<v-switch v-model="cookie.block_scripts" color="primary" hide-details class="mt-0 pt-0 ml-2" />
			</div>
			<v-text-field
				v-model.trim="cookie.policy_url"
				label="Link alla cookie policy"
				placeholder="/cookie-policy oppure https://…"
				hint="Pagina del sito (es. /cookie-policy) o indirizzo completo. Vuoto: il link non compare"
				persistent-hint
				prepend-inner-icon="mdi-link-variant"
				outlined
				dense
				class="mt-3"
			/>
			<v-alert dense text type="warning" class="mt-2 mb-0 cb-alert">
				Se negli Script c'è già un altro banner dei cookie (es. iubenda), toglilo: altrimenti il visitatore vede due richieste di consenso.
			</v-alert>
		</template>
	</div>
</template>

<script>
// cookie bar del sito pubblico (layout.cookie_bar), uguale in tutti i temi
export default {
	name: 'CookieBar',
	props: {
		// { enabled, block_scripts, policy_url }
		cookie: { type: Object, required: true },
	},
};
</script>

<style scoped>
.cb-switch {
	display: flex;
	align-items: center;
	padding: 10px 12px;
	border: 1px solid #e1e7ef;
	border-radius: 10px;
	background: #fff;
}
.cb-switch--on {
	border-color: #9fb6d3;
	background: #f7faff;
}
.cb-switch-text {
	flex: 1 1 auto;
	min-width: 0;
}
.cb-switch-label {
	font-size: 14px;
	font-weight: 600;
	color: #1f2d3d;
}
.cb-muted {
	font-size: 12px;
	color: #5f6b7a;
}
.cb-alert {
	font-size: 13px;
}
</style>
